// client/src/screens/admin/products/haberdashery/HaberdasherProductForm.jsx

import React from "react";
import useHaberdasheryForm from "./haberdashery/useHaberdasheryForm";
import HaberdasheryFormStatus from "./haberdashery/HaberdasheryFormStatus";
import HaberdasheryFormContent from "./haberdashery/HaberdasheryFormContent";
import HaberdasheryFormActions from "./haberdashery/HaberdasheryFormActions";

const HaberdasherProductForm = ({
  initialData,
  onSubmit,
  loading = false,
  error = "",
  errorMeta = null,
  saveSuccess = false,
  submitLabel = "Save Haberdashery Product",
  shopKey = "haberdashery",
  isEditing = false,
}) => {
  const {
    form,
    submitError,
    draftRestored,
    submitDisabled,
    conflictMessage,
    setField,
    setVariantField,
    setImages,
    addVariant,
    removeVariant,
    discardDraft,
    handleSubmit,
  } = useHaberdasheryForm({
    initialData,
    onSubmit,
    loading,
    error,
    errorMeta,
    saveSuccess,
    shopKey,
  });

  return (
    <form className="admin-product-form" onSubmit={handleSubmit}>
      <HaberdasheryFormStatus
        draftRestored={draftRestored}
        isEditing={isEditing}
        submitDisabled={submitDisabled}
        conflictMessage={conflictMessage}
        error={error}
        submitError={submitError}
        onDiscardDraft={discardDraft}
      />

      <HaberdasheryFormContent
        form={form}
        shopKey={shopKey}
        submitDisabled={submitDisabled}
        setField={setField}
        setVariantField={setVariantField}
        setImages={setImages}
        addVariant={addVariant}
        removeVariant={removeVariant}
      />

      <HaberdasheryFormActions
        loading={loading}
        submitDisabled={submitDisabled}
        submitLabel={submitLabel}
        onReset={discardDraft}
      />
    </form>
  );
};

export default HaberdasherProductForm;
